function home() {

    if ( !! $('#newvideolauncher').length ) {
        setTimeout(function() { $('#newvideolauncher').trigger('click');  }, 2500);
    }

    if ( !! $('div.player').length ) {
        $('div.player').on("click", function(){

            var theSS = $(this).attr('data-ss');

            if ($(this).hasClass('stop')) {
                $(this).removeClass('stop');
                $(this).addClass('play');
                $(`.${theSS} ul`).cycle('pause');
                $(this).html('<span class="fas fa-play fa-sm"></span>');

            } else {
                $(`.${theSS} ul`).cycle('resume');
                $(this).removeClass('play');
                $(this).addClass('stop');
                $(this).html('<span class="fas fa-pause"></span>');
            }
        });

    }

    if ( !! $('.slider').length ) {

        setTimeout(function() {
            $('.slider').fadeIn(600);
        },10);

        setTimeout(function() {
            $('.background-overlay > .loader').fadeOut(600);
        },1600);


        $('.home-slider').find('ul').cycle();


        if( !! $(".overbox").length) {

            setTimeout(function() { $('.overbox').fadeIn(600); }, 600);
        }

        if( !! $(".u-ad").length) {
            setTimeout(function() {
            }, 2000);


            $('#continue').on('click',function(){
                $('.u-ad').fadeOut(300);
            })
            $('.u-ad .top').on('click',function(){
                $('#continue').trigger('click');
            })

        }

    }

    $('.home-vid').find('ul').cycle();

    if( !! $(".home-vid").length) {

        $('div.home-vid ul').on( 'cycle-before', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {

            if ($('div.home-vid .pager span:nth-child(n+0)').hasClass('cycle-pager-active')) {
                $('div.home-vid .pager span').css({'position' : 'relative', 'top' : '0px'});
            }
            if ($('div.home-vid .pager span:nth-child(n+13)').hasClass('cycle-pager-active')) {
                $('div.home-vid .pager span').css({'position' : 'relative', 'top' : '-24px'});
            }
            if ($('div.home-vid .pager span:nth-child(n+26)').hasClass('cycle-pager-active')) {
                $('div.home-vid .pager span').css({'position' : 'relative', 'top' : '-50px'});
            }

        });

        $('div.home-vid ul').on( 'cycle-after', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {

            if ($('div.home-vid .pager span:nth-child(n+1)').hasClass('cycle-pager-active')) {
                $('div.home-vid .pager span').css({'position' : 'relative', 'top' : '0px'});
            }
            if ($('div.home-vid .pager span:nth-child(n+14)').hasClass('cycle-pager-active')) {
                $('div.home-vid .pager span').css({'position' : 'relative', 'top' : '-24px'});
            }
            if ($('div.home-vid .pager span:nth-child(n+27)').hasClass('cycle-pager-active')) {
                $('div.home-vid .pager span').css({'position' : 'relative', 'top' : '-50px'});
            }

        });

    }

    if( $("body.page-template-page-home-migrate-php").length && !! $(".ticket-meter").length  ) {
        GAmeterDance();
        if($(".vip-meter").length ) {
            setTimeout(function(){
                VIPmeterDance();
            }, vipdelay)
        }

    }

}
